import React, { useState } from 'react';
import './Review.css'; // Optional: for styling

function Review() {
  const [comment, setComment] = useState('');
  const [rating, setRating] = useState(0);
  const [reviews, setReviews] = useState([]);

  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const handleRatingChange = (value) => {
    setRating(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here (e.g., send to server)
    const review = {
      comment,
      rating,
    };
    setReviews([...reviews, review]);
    console.log('Reviews:', reviews);
    // Reset the form
    setComment('');
    setRating(0);
  };

  return (
    <div className="review-container">
      <h2>Customer Reviews</h2>
      <img src="customer.jpg.jpg" alt="Review" className="review-image" />
      <form onSubmit={handleSubmit}>
        <div className="rating">
          <span>Rate Us: </span>
          {[1, 2, 3, 4, 5].map((star) => (
            <span
              key={star}
              className={`star ${rating >= star ? 'filled' : ''}`}
              onClick={() => handleRatingChange(star)}
            >
              ★
            </span>
          ))}
        </div>
        <div>
          <textarea
            value={comment}
            onChange={handleCommentChange}
            placeholder="Leave your comment here..."
            required
          />
        </div>
        <button type="submit">Submit Review</button>
      </form>
      <h2>Reviews:</h2>
      <ul>
        {reviews.map((review, index) => (
          <li key={index}>
            <p>Rating: {review.rating}/5</p>
            <p>Comment: {review.comment}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Review;